/**
 * Catalog table for adjustment reasons returned by the current filters.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Badge, Button, Card, CardBody, Table } from 'reactstrap';

import {
  countryOptions,
  labelOptions,
  roleScopeOptions,
  scopeOptions,
  typeOptions,
} from '../constants';
import { getOptionLabel } from '../formHelpers';

const TableCard = ({ reasons, isFetching, onEdit }) => (
  <Card>
    <CardBody>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">Motivos existentes</h4>
        {isFetching && <Badge color="info">Cargando</Badge>}
      </div>
      <Table className="align-items-center table-flush" responsive hover>
        <thead className="thead-light">
          <tr>
            <th>Pais</th>
            <th>Tipo</th>
            <th>Scope</th>
            <th>Rol</th>
            <th>Label</th>
            <th>Descripcion</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {reasons.length === 0 && (
            <tr>
              <td colSpan="7" className="text-center">
                {isFetching ? 'Cargando motivos...' : 'No hay motivos para los filtros.'}
              </td>
            </tr>
          )}
          {reasons.map((reason) => (
            <tr key={reason.id}>
              <td>{getOptionLabel(countryOptions, reason.country)}</td>
              <td>{getOptionLabel(typeOptions, reason.type)}</td>
              <td>{getOptionLabel(scopeOptions, reason.scope)}</td>
              <td>{getOptionLabel(roleScopeOptions, reason.role_scope)}</td>
              <td>{getOptionLabel(labelOptions, reason.label)}</td>
              <td>{reason.description || '-'}</td>
              <td>
                <Button color="primary" size="sm" type="button" onClick={() => onEdit(reason)}>
                  Editar
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </CardBody>
  </Card>
);

TableCard.propTypes = {
  reasons: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    country: PropTypes.string,
    type: PropTypes.string,
    scope: PropTypes.string,
    role_scope: PropTypes.string,
    label: PropTypes.string,
    description: PropTypes.string,
  })).isRequired,
  isFetching: PropTypes.bool.isRequired,
  onEdit: PropTypes.func.isRequired,
};

export default TableCard;
